import React from "react"

import { Link, useTranslation } from "gatsby-plugin-react-i18next"

import { WordpressApi } from "../helpers/WordpressApi"

import PathTransformer from "./parsers/PathTransformer"
import PostLinkTransformer from "./parsers/PostLinkTransformer"

import { debounce } from "lodash"

import * as searchGooglishWidgetStyles from "../styles/SearchGooglishWidget.module.css"

function SearchGooglishWidget(props) {
  const [value, setValue] = React.useState("")

  const [isOpen, setIsOpen] = React.useState(false)
  const [isSearching, setIsSearching] = React.useState(false)
  const [results, setResults] = React.useState([])

  const { wordpressUrl } = props.pageContext

  const { t } = useTranslation()

  const _nativeSearch = async value => {
    const posts = await WordpressApi.getPosts(
      wordpressUrl,
      [],
      [],
      [],
      [],
      value,
      1,
      5,
    )
    const pages = await WordpressApi.getPages(
      wordpressUrl,
      [],
      [],
      [],
      [],
      value,
      1,
      5,
    )

    const postsData = (posts && posts.data) || []
    let pagesData = (pages && pages.data) || []
    pagesData.forEach(p => {
      p.categories.push(`page`)
    })

    const res = postsData.concat(pagesData).slice(0, 5)

    if (!res || !res.length) {
      setResults([])
    } else {
      setResults(
        res.map(r => ({
          categories: r.categories,
          title: r.title.rendered,
          synopsis: r.excerpt.rendered,
          link: r.link.replace(wordpressUrl, ``),
        })),
      )
    }
    setIsSearching(false)
    setIsOpen(true)
  }

  const onDataInput = async ({ value }) => {
    if (!value) {
      setIsOpen(false)
      return setResults([])
    }

    if (value.length > 0 && value.length < 3) return

    setIsOpen(false)
    setIsSearching(true)

    try {
      _nativeSearch(value)
    } catch (error) {
      console.log(error)
      setIsSearching(false)
      setIsOpen(false)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedEventBubble = React.useCallback(
    debounce(value => {
      onDataInput({ value: value })
    }, 1000),
    [],
  )

  const _updateQuery = value => {
    setValue(value)
    debouncedEventBubble(value)
  }

  return (
    <div className={searchGooglishWidgetStyles.wrapper}>
      <span className={searchGooglishWidgetStyles.widgetInput}>
        <input
          type="text"
          placeholder={props.placeholderText || ""}
          value={value}
          readOnly={isSearching}
          onChange={evt => _updateQuery(evt.target.value)}
          className={searchGooglishWidgetStyles.searchField}
        />
        <span style={{ display: "flex", alignItems: "center" }}>
          {isSearching && (
            <div
              className={`spinner-border text-dark ${
                isSearching
                  ? searchGooglishWidgetStyles.spinnerActive
                  : searchGooglishWidgetStyles.spinnerInactive
              }`}
              role="status"
            ></div>
          )}
          {isOpen && (
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="search"
              aria-label="Close"
              onClick={() => {
                setIsOpen(false)
                setResults([])
                setValue("")
              }}
            ></button>
          )}
        </span>
      </span>
      {isOpen && (
        <div className={searchGooglishWidgetStyles.widget}>
          <div className={searchGooglishWidgetStyles.results}>
            <hr className={searchGooglishWidgetStyles.resultsSeparator} />
            <ul className={searchGooglishWidgetStyles.resultEntryList}>
              {results &&
                results.map((res, idx) => (
                  <li
                    key={idx}
                    className={searchGooglishWidgetStyles.resultEntry}
                  >
                    {res.categories.includes(`page`) && (
                      <Link
                        className={searchGooglishWidgetStyles.resultEntryLink}
                        to={PathTransformer(
                          res.link,
                          props.pageContext.language,
                          props.pageContext.i18n.defaultLanguage,
                          props.pageContext.i18n.languages,
                        )}
                      >
                        <p
                          className={
                            searchGooglishWidgetStyles.resultEntryTitle
                          }
                          dangerouslySetInnerHTML={{ __html: res.title }}
                        />
                        <p
                          className={
                            searchGooglishWidgetStyles.resultEntrySynopsis
                          }
                          dangerouslySetInnerHTML={{ __html: res.synopsis }}
                        />
                      </Link>
                    )}
                    {!res.categories.includes(`page`) && (
                      <Link
                        className={searchGooglishWidgetStyles.resultEntryLink}
                        to={PostLinkTransformer(
                          res.link,
                          props.pageContext.language,
                          props.pageContext.i18n.defaultLanguage,
                          props.pageContext.i18n.languages,
                        )}
                      >
                        <p
                          className={
                            searchGooglishWidgetStyles.resultEntryTitle
                          }
                          dangerouslySetInnerHTML={{ __html: res.title }}
                        />
                        <p
                          className={
                            searchGooglishWidgetStyles.resultEntrySynopsis
                          }
                          dangerouslySetInnerHTML={{ __html: res.synopsis }}
                        />
                      </Link>
                    )}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchGooglishWidget
